var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "rotate(-180 12 12)",
    fill: "#4909AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C12.56 5 13 4.55 13 4V3C13 2.45 12.55 2 12 2C11.45 2 11 2.45 11 3V4C11 4.55 11.45 5 12 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.01 6.91L18.72 6.2C19.11 5.81 19.11 5.18 18.72 4.79C18.33 4.4 17.7 4.4 17.31 4.79L16.6 5.5C16.21 5.89 16.21 6.52 16.6 6.91C16.98 7.29 17.62 7.29 18.01 6.91Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 12.55 19.45 13 20 13H21C21.55 13 22 12.55 22 12C22 11.45 21.55 11 21 11H20C19.45 11 19 11.45 19 12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13H4C4.55 13 5 12.55 5 12C5 11.45 4.55 11 4 11H3C2.45 11 2 11.45 2 12C2 12.55 2.45 13 3 13Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99 6.91C6.38 7.3 7.01 7.3 7.4 6.91C7.79 6.52 7.79 5.89 7.4 5.5L6.69 4.79C6.3 4.4 5.67 4.4 5.28 4.79C4.89 5.18 4.89 5.81 5.28 6.2L5.99 6.91Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.98V19C9 20.1 9.9 21 11 21H13C14.1 21 15 20.1 15 19V15.98C16.43 14.9 17.28 13.08 16.91 11.07C16.55 9.12 15.01 7.52 13.07 7.12C9.84 6.44 7 8.89 7 12C7 13.63 7.79 15.06 9 15.98ZM11 16.9C11.32 16.96 11.66 17 12 17C12.34 17 12.68 16.96 13 16.9V19H11V16.9Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.314 12C14.314 11.931 14.3109 11.865 14.3048 11.796L14.8787 11.373C15.0021 11.283 15.036 11.115 14.9589 10.983L14.3819 10.014C14.3048 9.882 14.1382 9.828 13.9962 9.888L13.3329 10.161C13.2187 10.083 13.0984 10.014 12.9719 9.957L12.8824 9.264C12.8639 9.114 12.7312 9 12.577 9H11.4261C11.2688 9 11.1361 9.114 11.1176 9.264L11.0281 9.957C10.9016 10.014 10.7813 10.083 10.6671 10.161L10.0038 9.888C9.86184 9.828 9.69523 9.882 9.61809 10.014L9.04113 10.986C8.96399 11.118 8.99793 11.283 9.12135 11.376L9.69523 11.799C9.68906 11.865 9.68597 11.931 9.68597 12C9.68597 12.069 9.68906 12.135 9.69523 12.204L9.12135 12.627C8.99793 12.717 8.96399 12.885 9.04113 13.017L9.61809 13.986C9.69523 14.118 9.86184 14.172 10.0038 14.112L10.6671 13.839C10.7813 13.917 10.9016 13.986 11.0281 14.043L11.1176 14.736C11.1361 14.886 11.2688 15 11.423 15H12.5739C12.7281 15 12.8608 14.886 12.8793 14.736L12.9688 14.043C13.0953 13.986 13.2156 13.917 13.3298 13.839L13.9932 14.112C14.1351 14.172 14.3017 14.118 14.3788 13.986L14.9558 13.017C15.0329 12.885 14.999 12.72 14.8756 12.627L14.3017 12.204C14.3109 12.135 14.314 12.069 14.314 12ZM12.0123 13.05C11.4169 13.05 10.9325 12.579 10.9325 12C10.9325 11.421 11.4169 10.95 12.0123 10.95C12.6078 10.95 13.0922 11.421 13.0922 12C13.0922 12.579 12.6078 13.05 12.0123 13.05Z",
    fill: "#4909AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeation);
export default __webpack_public_path__ + "static/media/Ideation.76e0dc402d2cddea0835be3301f41aef.svg";
export { ForwardRef as ReactComponent };